import { RiArrowDownSLine } from "@itandi/itandi-bb-ui";
import React from "react";
import { DropdownList } from "~/components/common/parts/dropdown/DropdownList";
import { DropdownMenu } from "~/components/common/parts/dropdown/DropdownMenu";
import { SimpleDropdown } from "~/components/common/parts/dropdown/SimpleDropdown";
import type { BillingType } from "~/models/DealBilling";
import type { PropertyDealWithPrices } from "~/models/PropertyDeal";
import { getDownloadPath as getBillingDownloadPath } from "~/utils/api/property_deals/DealBillingFile";
import { getDownloadPath as getEstimationDownloadPath } from "~/utils/api/property_deals/DealEstimationFile";
import Styles from "./RelatedDealListTop.module.scss";

type Props = {
	propertyDeal: PropertyDealWithPrices;
};

/**
 * @for client
 * @constructor
 */
export function RelatedDealListTop({ propertyDeal }: Props) {
	const onClickEstimationSummaries = React.useCallback(() => {
		if (propertyDeal === null) {
			return;
		}
		const path = getEstimationDownloadPath(propertyDeal.id);
		window.open(path);
	}, [propertyDeal]);

	const onClickBillingSummaries = React.useCallback(
		(billingType: BillingType) => {
			if (propertyDeal === null) {
				return;
			}
			const path = getBillingDownloadPath(propertyDeal.id, billingType);
			window.open(path);
		},
		[propertyDeal]
	);
	return (
		<div className={Styles.TopContainer}>
			<h2 className={Styles.Title}>
				関連する案件一覧
				<span className={Styles.Count}>{`${propertyDeal.deals.length}件`}</span>
			</h2>
			<div className={Styles.ButtonArea}>
				<SimpleDropdown
					className={Styles.ButtonDropdown}
					placement="bottom-start"
					title={
						<span className={Styles.ButtonDropdownTitle}>
							見積・請求のサマリーを出力
							<RiArrowDownSLine className={Styles.Caret} />
						</span>
					}
				>
					<DropdownList>
						<DropdownMenu onClick={onClickEstimationSummaries}>
							施工会社からの見積
						</DropdownMenu>
						<DropdownMenu
							onClick={(): void => {
								onClickBillingSummaries("rentee");
							}}
						>
							入居者への請求
						</DropdownMenu>
						<DropdownMenu
							onClick={(): void => {
								onClickBillingSummaries("owner");
							}}
						>
							オーナーへの請求
						</DropdownMenu>
					</DropdownList>
				</SimpleDropdown>
			</div>
		</div>
	);
}
